









import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconMagnifyingGlass extends Vue {
    @Prop({ type: Number, default: 18 }) readonly size!: number
}
